import { Component, Input } from "@angular/core";
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { PonderDataClient } from "@apiserver-rest/ponder-data-client";
import { DataResponse, ProfileChanges, UpdateUserProfileRequest, User, UserProfile } from "@apiserver-rest/ponder-data-client-base";
import { AuthStorage } from "@ponder-core/auth/auth.storage";
import { EventBroker } from "@ponder-core/events/eventBroker";
import { SvgIcon, SvgIconMap } from "@ponder-shared/utils/svgIcons";
import { take } from "rxjs";

@Component({
    selector: "profile-info-form",
    imports: [ReactiveFormsModule],
    templateUrl: "./profile-info-form.component.html"
})
export class ProfileInfoFormComponent {
    @Input({ required: true }) public user!: User;
    @Input({ required: true }) public profile!: UserProfile;
    
    public readonly linkSvgIcon: string = SvgIconMap.get(SvgIcon.Link)!;

    public updateProfileForm = new FormGroup({
        displayName: new FormControl("", [ Validators.maxLength(128) ]),
        location: new FormControl("", [ Validators.maxLength(128) ]),
        website1: new FormControl("", [ Validators.maxLength(128) ]),
        website2: new FormControl("", [ Validators.maxLength(128) ]),
        website3: new FormControl("", [ Validators.maxLength(128) ]),
    }, { updateOn: 'change' });

    public isSaving: boolean = false;
    public savingFailed: boolean = false;

    constructor(private ponderDataClient: PonderDataClient, private events: EventBroker) {

    }

    public ngOnInit(): void {
        this.updateProfileForm.setValue({
            displayName: this.user.displayName ?? this.user.username!,
            location: this.profile.location ?? "",
            website1: this.profile.website ?? "",
            website2: this.profile.website2 ?? "",
            website3: this.profile.website3 ?? ""
        });
    }

    public getDisplayName(): string {
        return this.user?.displayName ?? this.user.username!;
    }

    public onCancel(): void {
        this.events.profile.hideProfileFormEvent.emit();
    }

    public onSubmit(): void {
        if (!this.canSubmit()) {
            return;
        }

        this.isSaving = true;
        this.savingFailed = false;

        var request = new UpdateUserProfileRequest({
            username: this.user.username,
            profileChanges: new ProfileChanges({
                displayName: this.updateProfileForm.value.displayName ?? undefined,
                location: this.updateProfileForm.value.location ?? undefined,
                website: this.updateProfileForm.value.website1 ?? undefined,
                website2: this.updateProfileForm.value.website2 ?? undefined,
                website3: this.updateProfileForm.value.website3 ?? undefined
            })
        });
        
        this.ponderDataClient
            .userProfilePatch(request)
            .pipe(take(1))
            .subscribe({
                next: (response: DataResponse) => {
                    if (response) {
                        this.user.displayName = request.profileChanges.displayName;
                        this.profile.location = request.profileChanges.location;
                        this.profile.website = request.profileChanges.website;
                        this.profile.website2 = request.profileChanges.website2;
                        this.profile.website3 = request.profileChanges.website3;

                        this.events.profile.hideProfileFormEvent.emit();
                        this.events.profile.displayNameUpdatedEvent.emit(this.user.displayName);
                    } else {
                        this.savingFailed = true;
                    }
                },
                error: () => {
                    this.savingFailed = true;
                }
            }).add(() => { this.isSaving = false; });
            

        this.events.profile.hideProfileFormEvent.emit();
    }

    public canSubmit(): boolean {
        return !this.isSaving && this.updateProfileForm.valid;
    }
}